import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    TECHNICAL_SOLUTION_APPLIED: {
        id: 'ase.priorityJustification.option.technicalSolutionApplied',
        defaultMessage: 'Technical solution applied (not included)'
    },
    TEHNICAL_BULLETIN_NOT_VISIBLE: {
        id: 'ase.priorityJustification.option.tehnicalBulletinNotVisible',
        defaultMessage: 'Technical Bulletin not visible'
    },
    OVERBILLING: {
        id: 'ase.priorityJustification.option.overbilling',
        defaultMessage: 'Overbilling'
    },
    GENERATES_CIR: {
        id: 'ase.priorityJustification.option.generatesCIR',
        defaultMessage: 'Generates CIR'
    },
    MULTIPLE_OCCURRENCE: {
        id: 'ase.priorityJustification.option.multipleOccurrence',
        defaultMessage: 'Multiple occurrence'
    },
    DNJ: {
        id: 'ase.priorityJustification.option.dnj',
        defaultMessage: 'DNJ'
    },
    DRG_CANCELED: {
        id: 'ase.priorityJustification.option.drgCanceled',
        defaultMessage: 'DRG canceled'
    },
});

export default messages;
